import { useSideNav } from "@/components/templates/SidebarLayout/SideNavContext";
import type React from "react";

interface AsideAreaProps {
  sidebar?: React.ReactNode;
  closeDelayMs?: number;
}

export const AsideArea: React.FC<AsideAreaProps> = ({ sidebar }) => {
  const { open } = useSideNav();

  return (
    <aside id="app-sidebar" aria-label="Main navigation" aria-hidden={!open} className={!open ? "is-collapsed" : ""}>
      <div className="app-layout__aside-panel">{sidebar}</div>
    </aside>
  );
};
